export const TARGET_SAMPLE_RATE = 44100
export const TARGET_CHANNELS = 1
// CBR bitrates wasm-media-encoders accepts (its parseParams throws on
// anything else, notably 56). We never target below MIN_TARGET_KBPS.
export type CbrKbps = 32 | 40 | 48 | 64 | 80 | 96 | 112 | 128 | 160 | 192 | 224 | 256 | 320
export const TARGET_KBPS: CbrKbps = 128
// At low bitrates LAME wants to drop the output sample rate (which many
// mp3 players, including esp-adf, can't play). We pin outputSampleRate to
// prevent that, and keep this floor so 44.1 kHz audio isn't starved for
// bits to the point of being unusable.
export const MIN_TARGET_KBPS: CbrKbps = 48
// Size the size-driven bitrate reduction aims for when re-encoding large
// sources — a quality/size tradeoff target, not an upload limit. Files that
// still exceed it are uploaded anyway.
export const TARGET_ENCODED_SIZE_BYTES = 10 * 1024 * 1024

export type EncodeRequest = {
  type: 'encode'
  jobId: number
  pcm: ArrayBuffer
  // Optional CBR bitrate. Falls back to TARGET_KBPS inside the worker.
  targetKbps?: CbrKbps
}

export type EncodeProgress = {
  type: 'progress'
  jobId: number
  percent: number
}

export type EncodeDone = {
  type: 'done'
  jobId: number
  mp3: ArrayBuffer
}

export type EncodeError = {
  type: 'error'
  jobId: number
  message: string
}

export type WorkerResponse = EncodeProgress | EncodeDone | EncodeError

export type Mp3FormatInfo = {
  channels: 1 | 2
  sampleRate: number
  kbps: number
}
